@if (hasGroupWithMessages()) {
  <div>
    @for (key of messageGroupList; track key) {
      @if (canShowGroup(key)) {
        <div class="td-wb-messages-group__section">
          <td-wb-page-panel>
            <div class="td-wb-messages-group__section-title"
                 [translate]="'tdWb.messages.' + key"></div>
          </td-wb-page-panel>
          <td-wb-messages [messages]="messageGroup[key].messages"
                          [expandMessages]="expandMessages()"
                          [updateMessageCounter]="updateMessagesCounter()" />
        </div>
      }
    }
  </div>
}
@if (!hasGroupWithMessages()) {
  <td-wb-empty>
    <td-wb-icon tdWbEmptyIcon
                iconId="email"
                size="64" />
    <td-wb-empty-header translate="tdWb.messages.NO_MESSAGES" />
  </td-wb-empty>
}
